<div id="divComponent" class="col-lg-12 col-md-12 col-sm-12 padding0px">
  <div id="div-component-content" class="row margin0px" style="margin-top:0.5rem">

    <div class="col-lg-12 col-md-12 col-sm-12 padding0px" style="line-height:23px;">
      <div class="col-lg-12 col-md-12 col-sm-12 padding0px text-alignment-right" style="margin-top: 4px; float: right; padding-right: 0.3rem">
        <dx-button text="Clear Filter" class="btn-secondary" hint="Clear Filter" (onClick)="ClearFilter($event)" style="width:auto; "></dx-button>
        <dx-button text="Clear Sorting" class="btn-secondary" hint="Clear Sorting" (onClick)="ClearSorting($event)" style="width:auto;"></dx-button>

        <dx-drop-down-button class="export-button"
                             [dropDownOptions]="{ width: 200 }"
                             widget="dxButton"
                             locateInMenu="always"
                             icon="export"
                             [items]="__lButtonItems"
                             displayExpr="name"
                             (onItemClick)="ExportToExcel($event)">
        </dx-drop-down-button>


        <!--<div class="btn-group dropdown" style="width: 100px; ">
          <button class="btn btn-info" type="button" id="btnExport" (click)="ExportToExcel(false)" style="float: left; width: 75%; ">
            Export
          </button>
          <button type="button" class="btn btn-info dropdown-toggle" data-toggle="dropdown" style="float: right; width: 25%;">
            <span class="caret"></span>
          </button>

          <ul class="dropdown-menu" role="menu" aria-labelledby="menu1" style="z-index:1000; left: -75px; ">
            <li role="presentation">
              <a role="menuitem" tabindex="-1" data-toggle="modal" (click)="ExportToExcel(false)">Export all data</a>
            </li>

            <li role="presentation">
              <a role="menuitem" tabindex="-1" (click)="ExportToExcel(true)">Export selected rows</a>
            </li>
          </ul>
        </div>-->

        <dx-button text="Add Row" hint="Add Row" (onClick)="AddRow($event)" [visible]="__bStateLessGridAddRowButtonVisible" style="width:auto; "></dx-button>
      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-sm-12 padding0px" style="padding-top: 0.7rem;">
      <dx-data-grid #statelessWorkflowTabGrid [ngClass]="__bIsChild ? 'dashboard-grid stateless-workflow-tabgridChild' : 'dashboard-grid stateless-workflow-tabgrid'" class="dashboard-grid stateless-workflow-tabgrid" id="statelessWorkflowTabGrid"
                    [dataSource]="__oBusinessProcessStatelessDataContext"
                    [(columns)]="__oStatelesscolumns"
                    [masterDetail]="__oStatelessGridMasterDetailOption"
                    [allowColumnReordering]="false"
                    [allowColumnResizing]="true"
                    columnResizingMode="widget"
                    [columnMinWidth]="100"
                    [columnAutoWidth]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                    [showBorders]="true"
                    [rowAlternationEnabled]="false"
                    [hoverStateEnabled]="true"
                    [wordWrapEnabled]="false"
                    [cellHintEnabled]="true"
                    [repaintChangesOnly]="true"
                    keyExpr="RowNumber"
                    [(selectedRowKeys)]="__oStatelessGridSelectedKeys"
                    (onRowPrepared)="onRowPrepared($event)"
                    (onCellClick)="onCellClick($event)"
                    style="min-width:100%;max-width:100%"
                    (onEditorPreparing)="datePickerService.onEditorPreparingMethod($event)">
        <!--<!(onCellPrepared) = "onCellPrepared($event)"---->
        <dxo-export [enabled]="false" [fileName]="__sBusinessProcessName" [allowExportSelectedData]="true"></dxo-export>
        <dxo-editing mode="cell"
                     [allowUpdating]="true"
                     [allowAdding]="false">
        </dxo-editing>
        <dxo-selection selectAllMode="allPages"
                       showCheckBoxesMode="always"
                       mode="multiple"></dxo-selection>
        <dxo-paging [pageSize]="100"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="__oBusinessProcessStatelessDataContext.length > 0"
                  [allowedPageSizes]="[10, 50 ,100]"      
                   [showInfo]="true"
                   [visible]="__oBusinessProcessStatelessDataContext.length > 0"
                   [showNavigationButtons]="true"
                   [displayMode]="'full'">
        </dxo-pager>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <!--<dxo-column-chooser mode="select" [enabled]="true"></dxo-column-chooser>-->
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-filter-row [visible]="true"
                        applyFilter="auto"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <div *dxTemplate="let Info of 'cellTemplateMultiline'">
          <dx-text-area [height]="35" [maxLength]="Info.data.TextSize[Info.columnIndex]" (onChange)="StatelessGridColumnValueChanged(Info.data.DataValue[Info.columnIndex],Info.data.RowNumber,Info.columnIndex,0)" [(value)]="Info.data.DataValue[Info.columnIndex]"></dx-text-area>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateComboBox'">
          <dx-select-box id="slb_itemSource"
                         [dataSource]="Info.data.ItemSource[Info.columnIndex]"
                         displayExpr="DisplayMember"
                         valueExpr="DisplayMember"
                         [(value)]="Info.data.DataValue[Info.columnIndex]"
                         (onSelectionChanged)="StatelessGridColumnValueChanged(Info.data.DataValue[Info.columnIndex],Info.data.RowNumber,Info.columnIndex,0)"
                         [searchEnabled]="true"
                         itemTemplate="item"
                         style="position:inherit">
            <div *dxTemplate="let data of 'item'">
              <div title="{{data.DisplayMember}}">{{data.DisplayMember}}</div>
            </div>
            
          </dx-select-box>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateMultiSelect'">
          <!--<dx-drop-down-box [(value)]="Info.data.MultiSelectedItems[Info.columnIndex]"
                            [dataSource]="Info.data.ItemSource[Info.columnIndex]"
                            valueExpr="DisplayMember"
                            displayExpr="DisplayMember"
                            placeholder="Select ..."
                            [showClearButton]="true"
                            style="background-color:lightgray"
                            (onValueChanged)="StatelessGridColumnValueChanged(Info.data.RowNumber,Info.columnIndex)"
                            [(opened)]="gridBoxValue">

            <div *dxTemplate="let contentData of 'content'">
              <dx-list [dataSource]="Info.data.ItemSource[Info.columnIndex]"
                       selectionMode="all"
                       itemTemplate="listItem"
                       [height]="400"
                       [selectAllMode]="true"
                       [showSelectionControls]="true"
                       keyExpr="DisplayMember"
                       [(selectedItemKeys)]="Info.data.MultiSelectedItems[Info.columnIndex]">
                <div *dxTemplate="let item of 'listItem'">
                  <b>{{item.DisplayMember}}</b><br />
                </div>
                <div class="dx-toolbar dx-widget dx-visibility-change-handler dx-collection dx-popup-bottom" role="toolbar">
                  <div class="dx-toolbar-items-container">
                    <div class="dx-toolbar-before"></div>
                    <div class="dx-toolbar-center" style="margin: 0px 225px 0px 0px; float: right;"></div>
                    <div class="dx-toolbar-after">
                      <div class="dx-item dx-toolbar-item dx-toolbar-button">
                        <div class="dx-item-content dx-toolbar-item-content">
                          <div class="dx-button dx-button-normal dx-widget dx-button-has-text" role="button" aria-label="OK" tabindex="0">
                            <div class="dx-button-content">
                              <span class="dx-button-text">OK</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="dx-item dx-toolbar-item dx-toolbar-button">
                        <div class="dx-item-content dx-toolbar-item-content">
                          <div class="dx-button dx-button-normal dx-widget dx-button-has-text" role="button" aria-label="Cancel" tabindex="0">
                            <div class="dx-button-content"><span class="dx-button-text">Cancel</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </dx-list>
            </div>
          </dx-drop-down-box>-->
          <dx-tag-box class="dxTagBox" [items]="Info.data.ItemSource[Info.columnIndex]"
                      [showSelectionControls]="true"
                      [searchEnabled]="true"
                      valueExpr="DisplayMember"
                      displayExpr="DisplayMember"
                      [(value)]="Info.data.MultiSelectedItems[Info.columnIndex]"
                      placeholder="Select ..."
                      applyValueMode="instantly"
                      [showClearButton]="true"
                      (onValueChanged)="StatelessGridColumnValueChanged(Info.data.MultiSelectedItems[Info.columnIndex], Info.data.RowNumber,Info.columnIndex,0)"
                      [(opened)]="gridBoxValue"
                      style="height: 50px;">
          </dx-tag-box>

        </div>

        <div *dxTemplate="let Info of 'cellTemplateAutoComplete'">
          <dx-autocomplete [dataSource]="Info.data.ItemSource[Info.columnIndex]"
                           valueExpr="DisplayMember"
                           [showClearButton]="true"
                           [searchTimeout]="500"
                           [(value)]="Info.data.DataValue[Info.columnIndex]"
                           (onValueChanged)="GetDataForStateLessACB(Info.columnIndex,Info.rowIndex,Info.data.RowNumber,$event)"
                           (onSelectionChanged)="StatelessGridColumnValueChangedACB(Info.data.RowNumber,Info.columnIndex,$event)"
                           [maxItemCount]="30"
                           (onFocusIn)="StateLessACBonFocusIn(Info.columnIndex,Info.rowIndex,Info.data.RowNumber,$event)"
                           [(opened)]="Info.data.Opened[Info.columnIndex]">
            <!--(onChange)="StatelessGridColumnValueChanged(Info.data.RowNumber,Info.columnIndex)"-->
          </dx-autocomplete>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateDate'">
          <app-date-picker type="date" [value]="Info.data.DataValue[Info.columnIndex]" (onDatePickerValueChanged)="StatelessGridColumnValueChanged($event.value,Info.data.RowNumber,Info.columnIndex,0, Info.data.DataValue)"
                       displayFormat="dd-MMM-yyyy" style="width:100% !important">
          </app-date-picker>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateCheckBox'">
          <dx-check-box [(value)]="Info.data.DataValue[Info.columnIndex]" (onValueChanged)="StatelessGridColumnValueChanged(Info.data.DataValue[Info.columnIndex],Info.data.RowNumber,Info.columnIndex,0)">
          </dx-check-box>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateAmount'">
          <dx-number-box [step]="0" [format]="Info.data.NumberFormat[Info.columnIndex]" [min]="Info.data.MinNum[Info.columnIndex]" [max]="Info.data.MaxNum[Info.columnIndex]"
                         (onKeyUp)="onKeyPressNumberBoxSLGrid($event,Info.data,Info.columnIndex,Info.rowIndex)" (onChange)="StatelessGridColumnValueChanged(Info.data.DataValue[Info.columnIndex],Info.data.RowNumber,Info.columnIndex,1)"
                         [(value)]="Info.data.DataValue[Info.columnIndex]" style="text-align:right;"></dx-number-box>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateMultilineReadOnly'">
          <dx-text-area [height]="50" [readOnly]="true" [maxLength]="Info.data.TextSize[Info.columnIndex]" [value]="Info.data.DataValue[Info.columnIndex]"></dx-text-area>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateDateReadOnly'">
          <app-date-picker type="date" [disabled]="true" [value]="Info.data.DataValue[Info.columnIndex]" displayFormat="dd-MMM-yyyy">
          </app-date-picker>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateCheckBoxReadOnly'">
          <dx-check-box [disabled]="true" [value]="Info.data.DataValue[Info.columnIndex]">
          </dx-check-box>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateAmountReadOnly'">
          <dx-number-box [step]="0" [readOnly]="true" format="#,##0.##" [value]="Info.data.DataValue[Info.columnIndex]" style="text-align:right;"></dx-number-box>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateMultilineInvisible'">
          <dx-text-area [disabled]="true" [maxLength]="Info.data.TextSize[Info.columnIndex]" [height]="35" [readOnly]="true"
                        [value]="calculateCellValue(Info.columnIndex)">
          </dx-text-area>
        </div>

        <div *dxTemplate="let Info of 'cellTemplate'" style="margin-left:10px;padding:0px !important">
          <div *ngFor="let item of Info.data.Actions ; let i = index" style="padding:1px 1px 0 1px; float: left; ">
            <dx-button class="btn-secondary" [text]="item.Name" [hint]="item.Name" [width]="item.Width"
                       (onClick)="ExecuteStatelessUserAction(Info.data.RowNumber, item)" style="height:25px;padding:0px !important"></dx-button>
          </div>
          <!--<dx-button text="..." style="width:100px;" (onClick)="TestStateLess($event, Info)" >
          </dx-button>-->
        </div>

        <div *dxTemplate="let Info of 'cellTemplate1'">
          <dx-button text="..." style="width:20px;" (onClick)="TestStateLess($event, Info)">
          </dx-button>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateDataReferenceReadOnly'">
          <a title="{{Info.data.DataValue[Info.columnIndex]}}" class="nav-link clickable"
             (click)="OpenReferenceDataURLStateLess(Info.columnIndex, Info.rowIndex, Info.data.RowNumber)">{{Info.data.DataValue[Info.columnIndex]}}</a>
        </div>

        <div *dxTemplate="let Info of 'cellTemplateURLReadOnly'">
          <a title="{{Info.data.DataValue[Info.columnIndex]}}" class="nav-link clickable"
             (click)="OpenURLFromGridRow(Info.columnIndex, Info.data.RowNumber)">{{Info.data.DataValue[Info.columnIndex]}}</a>
        </div>

        <div *dxTemplate="let StatelessRow of 'detail'">
          <div class="row padding0px">
            <div class="col-lg-6 col-md-6 col-sm-6">
              <div *ngFor="let item of StatelessRow.data.BusinessProcessStateLessDefinitionDetails; let i = index; let even = even;">
                <div *ngIf="item.DisplayOrder % 2 === 0">

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Combo Box'" style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-select-box id="selecbox{{i}}"
                                     [dataSource]="item.ItemSource"
                                     displayExpr="DisplayMember"
                                     valueExpr="DisplayMember"
                                     [(value)]="item.DataValue"
                                     [readOnly]="item.IsReadOnly"
                                     [searchEnabled]="true"
                                     (onSelectionChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)">
                        
                      </dx-select-box>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Multi Select Combo Box'" style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <!--<dx-drop-down-box [(value)]="item.MultiSelectedItems"
                                        [dataSource]="item.ItemSource"
                                        valueExpr="DisplayMember"
                                        displayExpr="DisplayMember"
                                        placeholder="Select ..."
                                        [showClearButton]="true"
                                        style="background-color:lightgray"
                                        (onValueChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)"
                                        [disabled]="item.IsReadOnly">

                        <div *dxTemplate="let contentData of 'content'">
                          <dx-list [dataSource]="item.ItemSource"
                                  selectionMode="all"
                                  itemTemplate="listItem"
                                  [height]="400"
                                  [selectAllMode]="true"
                                  [showSelectionControls]="true"
                                  keyExpr="DisplayMember"
                                  [(selectedItemKeys)]="item.MultiSelectedItems">

                            <div *dxTemplate="let item of 'listItem'">
                              <b>{{item.DisplayMember}}</b><br />
                            </div>
                          </dx-list>
                        </div>
                      </dx-drop-down-box>-->
                      <dx-tag-box class="dxTagBox" [items]="item.ItemSource"
                                  [showSelectionControls]="true"
                                  [searchEnabled]="true"
                                  valueExpr="DisplayMember"
                                  displayExpr="DisplayMember"
                                  [(value)]="item.MultiSelectedItems"
                                  placeholder="Select ..."
                                  applyValueMode="instantly"
                                  [showClearButton]="true"
                                  (onValueChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)"
                                  style="height: 50px;">
                      </dx-tag-box>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Auto Complete Box Sql'" style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-autocomplete [placeholder]="item.ColumnHeader"
                                      [dataSource]="item.ItemSource"
                                      valueExpr="DisplayMember"
                                      [showClearButton]="true"
                                      [searchTimeout]="500"
                                      [(value)]="item.DataValue"
                                      (onValueChanged)="GetDataForStateLessDetailACB(StatelessRow.data.RowNumber,item.ColumnName)"
                                      (onChange)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)"
                                      [maxItemCount]="30"
                                      [(opened)]="item.Opened"
                                      [disabled]="item.IsReadOnly">
                        <!--[(opened)]="opened"-->
                      </dx-autocomplete>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Multiline Text Box' " style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-text-area [height]="item.Height" [maxLength]="item.TextSize" [readOnly]="item.IsReadOnly" (onChange)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)" [placeholder]="item.ColumnHeader" [(value)]="item.DataValue"></dx-text-area>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Date' " style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <app-date-picker type="date" [value]="item.DataValue" [disabled]="item.IsReadOnly" (onValueChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName, $event, item.DataValue)" placeholder="dd-MMM-yyyy" displayFormat="dd-MMM-yyyy">
                        
                      </app-date-picker>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Amount' " style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-number-box [step]="0" [format]="item.FormatString" [min]="item.Min" [max]="item.Max" (onKeyUp)="onKeyPressNumberBoxSLDetail($event,item,StatelessRow.data.RowNumber)" (onValueChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)" [(value)]="item.DataValue" [readOnly]="item.IsReadOnly" style="text-align:right;"></dx-number-box>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Check Box' " style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-check-box [(value)]="item.DataValue" [disabled]="item.IsReadOnly" (onValueChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)">
                      </dx-check-box>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='NULL' " style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-text-area [height]="150" [maxLength]="item.TextSize" [readOnly]="item.IsReadOnly" [placeholder]="item.ColumnHeader" (onChange)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)" [(value)]="item.DataValue"></dx-text-area>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-6">
              <div *ngFor="let item of StatelessRow.data.BusinessProcessStateLessDefinitionDetails; let i = index; let even = even;">
                <div *ngIf="item.DisplayOrder % 2 > 0">
                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Combo Box'" style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-select-box id="selecbox{{i}}2"
                                     [dataSource]="item.ItemSource"
                                     displayExpr="DisplayMember"
                                     valueExpr="DisplayMember"
                                     [(value)]="item.DataValue"
                                     [readOnly]="item.IsReadOnly"
                                     [searchEnabled]="true"
                                     (onSelectionChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)">
                        
                      </dx-select-box>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Multi Select Combo Box'" style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <!--<dx-drop-down-box [(value)]="item.MultiSelectedItems"
                                        [dataSource]="item.ItemSource"
                                        valueExpr="DisplayMember"
                                        displayExpr="DisplayMember"
                                        placeholder="Select ..."
                                        [showClearButton]="true"
                                        style="background-color:lightgray"
                                        (onValueChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)"
                                        [disabled]="item.IsReadOnly">

                        <div *dxTemplate="let contentData of 'content'">
                          <dx-list [dataSource]="item.ItemSource"
                                  selectionMode="all"
                                  itemTemplate="listItem"
                                  [height]="400"
                                  [selectAllMode]="true"
                                  [showSelectionControls]="true"
                                  keyExpr="DisplayMember"
                                  [(selectedItemKeys)]="item.MultiSelectedItems">

                            <div *dxTemplate="let item of 'listItem'">
                              <b>{{item.DisplayMember}}</b><br />
                            </div>
                          </dx-list>
                        </div>
                      </dx-drop-down-box>-->
                      <dx-tag-box [items]="item.ItemSource"
                                  [showSelectionControls]="true"
                                  [searchEnabled]="true"
                                  valueExpr="DisplayMember"
                                  displayExpr="DisplayMember"
                                  [(value)]="item.MultiSelectedItems"
                                  placeholder="Select ..."
                                  applyValueMode="instantly"
                                  [showClearButton]="true"
                                  (onValueChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)"
                                  style="height: 50px;">
                      </dx-tag-box>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Auto Complete Box Sql'" style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-autocomplete [placeholder]="item.ColumnHeader"
                                      [dataSource]="item.ItemSource"
                                      valueExpr="DisplayMember"
                                      [showClearButton]="true"
                                      [searchTimeout]="500"
                                      [(value)]="item.DataValue"
                                      (onValueChanged)="GetDataForStateLessDetailACB(StatelessRow.data.RowNumber,item.ColumnName)"
                                      (onChange)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)"
                                      [maxItemCount]="30"
                                      [(opened)]="item.Opened"
                                      [disabled]="item.IsReadOnly">
                        <!--[(opened)]="opened"-->
                      </dx-autocomplete>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Multiline Text Box' " style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-text-area [height]="item.Height" [maxLength]="item.TextSize" [readOnly]="item.IsReadOnly" (onChange)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)" [placeholder]="item.ColumnHeader" [(value)]="item.DataValue"></dx-text-area>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Date' " style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <app-date-picker type="date" [value]="item.DataValue" [disabled]="item.IsReadOnly" (onValueChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName, $event, item.DataValue)" placeholder="dd-MMM-yyyy" displayFormat="dd-MMM-yyyy">
                      </app-date-picker>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Amount' " style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-number-box [step]="0" [format]="item.FormatString" [min]="item.Min" [max]="item.Max" (onKeyUp)="onKeyPressNumberBoxSLDetail($event,item,StatelessRow.data.RowNumber)" (onValueChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)" [(value)]="item.DataValue" [readOnly]="item.IsReadOnly" style="text-align:right;"></dx-number-box>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='Check Box' " style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-check-box [(value)]="item.DataValue" [disabled]="item.IsReadOnly" (onValueChanged)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)">
                      </dx-check-box>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="item.wfBusinessProcessStatelessInputType =='NULL' " style="padding-top:5px;padding-left:2px;">
                    <div class="dx-field-label">{{item.ColumnHeader}}</div>
                    <div class="dx-field-value">
                      <dx-text-area [height]="150" [maxLength]="item.TextSize" [readOnly]="item.IsReadOnly" [placeholder]="item.ColumnHeader" (onChange)="StatelessGridDetailColumnValueChanged(StatelessRow.data.RowNumber,item.ColumnHeader,item.ColumnName)" [(value)]="item.DataValue"></dx-text-area>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="StatelessRow.data.BusinessProcessStateLessDefinitionDetails?.length  > 0"
               style="height:35px; overflow-x:auto;padding:0px; ">
            <div style="float:right">
              <div *ngFor="let item of StatelessRow.data.Actions; let i = index"
                   style="float:left; padding:4px 1px 0 1px; ">
                <dx-button [text]="item.Name" [hint]="item.Name" [width]="item.Width"
                           (onClick)="ExecuteStatelessUserAction(StatelessRow.data.RowNumber, item)" style="height:25px;padding:0px !important"></dx-button>
              </div>
            </div>
          </div>
        </div>
        <dxo-summary [recalculateWhileEditing]="true" [totalItems]="__ototalItems">

        </dxo-summary>
      </dx-data-grid>
    </div>

  </div>


  <div class="col-lg-12 col-md-12 col-sm-12 padding0px" style="margin-top: 0.3rem; ">
    <div id="div-action-btn" class="col-lg-12 col-md-12 col-sm-12 padding0px" style="height:35px; overflow-x:auto;">
      <!--<div class="col-lg-1 col-md-2 col-sm-2" *ngFor="let item of __oBusinessProcessStateLessCommonAction; let i = index"
           style="padding:4px 2px 0 2px; float:right; padding-top:4px;">
        <dx-button [text]="item.Name" [hint]="item.Name" [width]="item.Width"
                   (onClick)="ExecuteStatelessUserActionCommon($event, item)" style="height:25px;padding:0px !important"></dx-button>
      </div>-->
      <ng-container *ngFor="let item of __oBusinessProcessStateLessCommonAction; let i = index">
        <td style="float:right;margin:3px 0px;">
          <dx-button [text]="item.Name" [hint]="item.Name" [width]="item.Width"
                     (onClick)="ExecuteStatelessUserActionCommon($event, item)" style="height:25px;padding:0px !important"></dx-button>
        </td>
      </ng-container>
    </div>
  </div>

</div>

<dx-load-panel id="pnlLoad"
               shadingColor="rgba(0,0,0,0.4)"
               [position]="{ at: 'center' }"
               [(visible)]="__bIsLoadingVisible"
               [showIndicator]="true"
               [showPane]="true"
               [shading]="true"
               [hideOnOutsideClick]="false"
               [height]="75"
               [width]="150"
               message="Please Wait...">
</dx-load-panel>

<app-confirmation [__iPopupHeight]="'auto'"></app-confirmation>
